import { render, staticRenderFns } from "./BatchImports.vue?vue&type=template&id=22e7f713&scoped=true"
import script from "./BatchImports.vue?vue&type=script&lang=js"
export * from "./BatchImports.vue?vue&type=script&lang=js"
import style0 from "./BatchImports.vue?vue&type=style&index=0&id=22e7f713&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e7f713",
  null
  
)

export default component.exports